module.exports = __webpack_public_path__ + "img/2.58544555.jpg";